"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroDuService() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative min-h-screen w-full overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520072/img/cloud_transformation_hero_abstract.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-background/60 backdrop-blur-sm" />

      {}
      <div className="relative z-10 flex min-h-screen items-center justify-center px-4 py-16">
        <div className={`glass-effect max-w-3xl border-2 border-primary/30 px-8 py-12 text-center shadow-strong transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] md:px-16 md:py-16 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          {}
          <h1 className="mb-4 font-bold leading-tight text-foreground !text-[38px] !font-serif">Stratégie Cloud & Transformation</h1>

          {}
          <p className="mb-8 text-lg leading-relaxed text-muted-foreground md:text-xl">
            Hybride, multi-cloud, cloud souverain, modèles opérationnels, gouvernance.
          </p>

          {}
          <Link to="/#contact">
            <Button size="lg" className="shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-105 hover:shadow-strong">Parlons Cloud</Button>
          </Link>
        </div>
      </div>
    </section>;
}